import type { ApiResponse, Pagination } from "@/types";

import { BaseApi } from "../base.api";

export type NotificationType =
  | "ENROLLMENT"
  | "PAYMENT_RECEIVED"
  | "ASSIGNMENT_SUBMITTED"
  | "ASSIGNMENT_RESUBMITTED"
  | "ASSIGNMENT_GRADED"
  | "ASSIGNMENT_RETURNED"
  | "COURSE_SUBMITTED"
  | "COURSE_PUBLISHED"
  | "COURSE_REJECTED"
  | "POST_APPROVED"
  | "POST_REJECTED"
  | "QUIZ_ATTEMPT_REQUESTED"
  | "QUIZ_ATTEMPT_APPROVED"
  | "QUIZ_ATTEMPT_REJECTED"
  | "REVIEW_APPROVED"
  | "TEACHER_REQUEST_SUBMITTED"
  | "TEACHER_REQUEST_APPROVED"
  | "TEACHER_REQUEST_REJECTED"
  | "NEW_ANNOUNCEMENT"
  | "NEW_COMMENT"
  | "NEW_RATING"
  | "CERTIFICATE_ISSUED"
  | "COURSE_UPDATED"
  | "SESSION_STARTED"
  | "SESSION_CANCELLED"
  | "SESSION_RESCHEDULED"
  | "SESSION_ADDED"
  | "SESSION_REMINDER"
  | "DEADLINE_REMINDER"
  | "ENROLLMENT_REMOVED"
  | "ENROLLMENT_READMITTED"
  | "COURSE_FINISHED"
  | "WEEKLY_REPORT"
  | "PAYMENT_REVIEW_REQUESTED"
  | "WITHDRAWAL_REQUESTED"
  | "REFUND_REQUESTED"
  | "SYSTEM";

export interface AppNotification {
  id: number;
  userId: number;
  actorId: number | null;
  type: NotificationType;
  title: string;
  message: string;
  data: Record<string, unknown> | null;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationFilter {
  page?: number;
  limit?: number;
  unread?: boolean;
}

/** Bildirishnomalar API — backend'dagi `NotificationsController` ning ko'zgusi. */
export class NotificationsApi extends BaseApi {
  private readonly baseUrl: string = "/notifications";

  list(filter: NotificationFilter = {}) {
    return this.request.get<AppNotification[], Pagination<AppNotification>>(this.baseUrl, {
      params: filter,
    });
  }

  unreadCount() {
    return this.request.get<{ count: number }, ApiResponse<{ count: number }>>(
      `${this.baseUrl}/unread-count`,
    );
  }

  markRead(id: number) {
    return this.request.patch<AppNotification, ApiResponse<AppNotification>>(
      `${this.baseUrl}/${id}/read`,
      {},
    );
  }

  markAllRead() {
    return this.request.patch<{ updated: number }, ApiResponse<{ updated: number }>>(
      `${this.baseUrl}/read-all`,
      {},
    );
  }
}

export const notificationsApi = new NotificationsApi();
